import styled from 'styled-components';
import { WaringModal } from '../../../modal/WaringModal';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { goToTournament } from '../../../../utils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { PROGRESS_TICKET_CONSTANTS, getCongratsText } from '../../../../constants/progressTicket';
import { ProgressTicketCommonProps } from '../ProgressTicket';

export const ProgressTicketMobile = ({
  goOnlineTab,
  goMainEventTab,
  ticketCnt,
  isActiveTicket,
  showWarningModal,
  setShowWarningModal,
  hasTicketNum,
}: ProgressTicketCommonProps) => {
  const { getText } = useTextVariant(PROGRESS_TICKET_CONSTANTS, true);

  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={() => setShowWarningModal(true)} />
          <TicketImgMobile
            src={isActiveTicket ? ImageUtils.TicketActive : ImageUtils.TicketInActive}
            alt="ParticipateInfo"
          />
        </ImgContainer>
        <CountContainer>
          <TopInfo>
            <CountCnt>
              {ticketCnt}
              <CountUnit>장</CountUnit>
            </CountCnt>
            <RemainContainer>
              <RemainText>{getText('remainText')}</RemainText>
            </RemainContainer>
            <RemainSubText>{getText('remainSubText')}</RemainSubText>
          </TopInfo>

          {isActiveTicket ? (
            <BottomInfo>
              <CongratsText>{getText('congratsText')}</CongratsText>
              <CongratsSubText>{getCongratsText(hasTicketNum || 0, true)}</CongratsSubText>
              <CongratsSubText>{getText('congratsSubText2')}</CongratsSubText>
            </BottomInfo>
          ) : (
            <BottomInfo>
              <NeedTicketSubTitle>{getText('needTicketSubTitle')}</NeedTicketSubTitle>
              <NeedTicketText>{getText('needTicketText')}</NeedTicketText>
              <NeedTicketSubText>{getText('needTicketSubText')}</NeedTicketSubText>
            </BottomInfo>
          )}
        </CountContainer>
      </Container>
      <BottomTabContainer>
        <CheckParticipateBtn onClick={goOnlineTab}>
          {getText('checkParticipateBtn')}
        </CheckParticipateBtn>
        <GoTournamentBtn onClick={goToTournament}>{getText('goTournamentBtn')}</GoTournamentBtn>
      </BottomTabContainer>

      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

const TopInfo = styled.div`
  height: 255px;
  background-color: transparent;
  border-radius: 8px;
  padding: 10px;
`;

const BottomInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 110px;
  background-color: transparent;
  border-radius: 8px;
`;

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImgMobile = styled.img`
  width: 344px;
  height: 386px;
`;

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  padding-bottom: 130px;
`;

const CountContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

const RemainContainer = styled.div`
  margin: 0 auto;
  margin-bottom: 9px;
  border-top: 1.5px solid rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.1);
  padding-top: 2px;
  width: 230px;
  height: 29px;
`;

const RemainText = styled.h3`
  font-weight: 800;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 22px;
`;

const RemainSubText = styled.h4`
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  span {
    font-weight: 800;
  }
`;

const NeedTicketText = styled.h3`
  color: #000;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: -0.8px;
`;

const NeedTicketSubText = styled.h4`
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.64px;
`;

const NeedTicketSubTitle = styled(NeedTicketSubText)`
  font-weight: 900;
  font-size: 16px;
`;

const CountCnt = styled.p`
  font-weight: bold;
  font-size: 96px;
  line-height: 140px;
`;

const CountUnit = styled.span`
  font-size: 24px;
  line-height: 32px;
`;

const QuestionIcon = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});
  width: 25px;
  height: 25px;
  right: 15px;
  top: 20px;
  background-size: contain;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const CheckParticipateBtn = styled.button`
  height: 70px;
  width: 30%;
  left: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background-color: #a91f52;

  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;

  color: #ffffff;
  white-space: pre-wrap;
`;

const GoTournamentBtn = styled.button`
  left: 30%;
  height: 70px;
  width: 70%;
  cursor: pointer;
  background-color: #7e0f45;

  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;

const CongratsText = styled.h3`
  color: #d2006d;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.96px;
`;

const CongratsSubText = styled.h4`
  color: #d50087;

  text-align: center;
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.64px;

  span {
    color: #000;
    text-decoration-line: underline;
  }
`;
